// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"pz","carousel__wrapper_on_sides":"qz","arrows_wrapper":"rz","arrows_wrapper_right":"sz","arrows_wrapper_vertical":"tz","arrows_wrapper_on_sides":"uz","arrow_button":"vz","carousel_arrow_left":"wz","carousel_arrow_left_on_side":"xz","carousel_arrow_right_on_side":"yz","carousel_arrow":"zz","arrows_wrapper_rounded":"Az","carousel__fullWidth":"Bz"};
    if(module.hot) {
      // 1714442369170
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  